import React from 'react';
import { ArrowRight } from 'lucide-react';

const SecondOpinion = () => {
  return (
    <section id="second-opinion" className="py-16 lg:py-24 bg-white">
      <div className="max-w-[1240px] mx-auto px-6">
        <div className="relative rounded-[28px] overflow-hidden hex-pattern px-8 lg:px-20 py-16 lg:py-24 text-center">
          <h2 className="relative z-10 text-[36px] lg:text-[52px] leading-[1.05] font-bold tracking-tight text-neutral-900">
            Not Sure Where to <span className="font-serif-italic font-normal">Start?</span>
          </h2>
          <p className="relative z-10 mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-neutral-700">
            Book a complimentary 15-minute injury screen with one of our physiotherapists.
            We&rsquo;ll listen to your story, take a quick look, and point you toward the right
            care&mdash;whether that&rsquo;s with us or somewhere else entirely.
          </p>
          <a href="tel:+15192522752" className="relative z-10 mt-8 inline-flex items-center gap-2 bg-[#CA0028] hover:bg-[#A80021] text-white text-[14px] font-medium pl-6 pr-2 py-2 rounded-full transition-colors">
            Call to Book a Free Injury Screen
            <span className="w-8 h-8 grid place-items-center rounded-full bg-white/10">
              <ArrowRight size={14} />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default SecondOpinion;
